import { useRef } from "react";

export function useClickDoubleClick(
  onClick: any,
  onDoubleClick: any,
  delay = 250
) {
  const clickTimeout: any = useRef(null);

  const handler = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    if (clickTimeout.current) {
      // second click → DOUBLE CLICK
      clearTimeout(clickTimeout.current);
      clickTimeout.current = null;
      onDoubleClick && onDoubleClick(e);
    } else {
      // first click → WAIT
      clickTimeout.current = setTimeout(() => {
        onClick && onClick(e);
        clickTimeout.current = null;
      }, delay);
    }
  };

  return { handler };
}
